import Vue from "vue";

import UserApi from "@/api/user.api";

const errorHandler = error => {
    Vue.prototype.$eventHub.$emit("profile.error", error);
};

const actions = {
    async fetchProfile({ commit }) {
        commit("setLoading");
        const { data } = await UserApi.Profile.get().catch(errorHandler);
        commit("setData", data);
        commit("setLoading", false);
    },
    async pushType({ commit }, type) {
        const { data } = await UserApi.Profile.setType(type).catch(errorHandler);
        commit("setData", data);
    },
    async pushData({ commit }, form) {
        const { data } = await UserApi.Profile.setData(form).catch(errorHandler);
        commit("setData", data);
    },
    async sendToVerify({ commit }) {
        const { data } = await UserApi.Profile.sendToVerify().catch(errorHandler);
        commit("setData", data);
    },
    async fetchDocuments({ commit }) {
        const { data } = await UserApi.Profile.getDocuments().catch(errorHandler);
        commit("setDocuments", data);
    },
    async fetchAccounts({ commit }) {
        const { data } = await UserApi.Profile.getAccounts().catch(errorHandler);
        commit("setAccounts", data);
    },
    async fetchCertificate({ commit }) {
        const { data } = await UserApi.Profile.getCertificate().catch(errorHandler);
        commit("setCertificate", data);
    },
    async backToFill({ commit }) {
        const { data } = await UserApi.Profile.backToFill().catch(errorHandler);
        commit("setData", data);
    },
    async changeReportStatus({ commit }) {
        const { data } = await UserApi.Profile.changeReportStatus().catch(errorHandler);
        commit("setData", data);
    },
};

export default actions;
